module.exports = __webpack_public_path__ + "img/NK.3ca2fb19.png";